import { render, staticRenderFns } from "./GrowthPerformance.vue?vue&type=template&id=2038c497&scoped=true&"
import script from "./GrowthPerformance.vue?vue&type=script&lang=js&"
export * from "./GrowthPerformance.vue?vue&type=script&lang=js&"
import style0 from "./GrowthPerformance.vue?vue&type=style&index=0&id=2038c497&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2038c497",
  null
  
)

export default component.exports